module.exports = "<div gw-pl-ctrl-group label=\"{{label}}\" model=\"model\">\r\n    <div gw-pl-binary-choice\r\n         model=\"model\"\r\n         title-left=\"{{titleLeft}}\" title-right=\"{{titleRight}}\"\r\n         value-left=\"valueLeft\" value-right=\"valueRight\">\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/platform/widgets/inputs/templates/binary-choice-group.html
// module id = 409
// module chunks = 0